import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookie_consent_v1";

export default function CookieConsent() {
  const [isMounted, setIsMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsMounted(true);

    try {
      const savedConsent = localStorage.getItem(STORAGE_KEY);
      if (!savedConsent) {
        setIsVisible(true);
      }
    } catch (error) {
      setIsVisible(true);
    }
  }, []);

  const handleConsent = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      console.error("Could not save cookie consent:", error);
    }

    setIsVisible(false);
  };

  if (!isMounted || !isVisible) return null;

  return (
    <div style={styles.wrapper} aria-live="polite" aria-label="Cookie consent banner">
      <div style={styles.card} role="dialog" aria-modal="false" aria-labelledby="cookie-title">
        <div style={styles.content}>
          <div style={styles.iconWrap}>
            <span style={styles.icon}>🍪</span>
          </div>

          <div style={styles.textWrap}>
            <h3 id="cookie-title" style={styles.title}>
              We use cookies
            </h3>

            <p style={styles.text}>
              We use cookies to improve your browsing experience, analyze traffic,
              and enhance website performance. By clicking <strong>Accept</strong>,
              you agree to our use of cookies.
            </p>

            <p style={styles.subText}>
              Read our{" "}
              <Link to="/cookies" style={styles.link}>
                Cookie Policy
              </Link>{" "}
              and{" "}
              <Link to="/policy" style={styles.link}>
                Privacy Policy
              </Link>
              .
            </p>
          </div>
        </div>

        <div style={styles.actions}>
          <button
            type="button"
            onClick={() => handleConsent("declined")}
            style={styles.secondaryBtn}
            aria-label="Decline cookies"
          >
            Decline
          </button>

          <button
            type="button"
            onClick={() => handleConsent("accepted")}
            style={styles.primaryBtn}
            aria-label="Accept cookies"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    left: "16px",
    right: "16px",
    bottom: "16px",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    pointerEvents: "none",
  },

  card: {
    width: "100%",
    maxWidth: "760px",
    background: "rgba(255, 255, 255, 0.96)",
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: "20px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
    padding: "20px",
    pointerEvents: "auto",
    animation: "fadeUp 0.35s ease",
  },

  content: {
    display: "flex",
    gap: "16px",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },

  iconWrap: {
    width: "48px",
    height: "48px",
    minWidth: "48px",
    borderRadius: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #f5f5f5, #eaeaea)",
    fontSize: "22px",
  },

  icon: {
    lineHeight: 1,
  },

  textWrap: {
    flex: 1,
    minWidth: "240px",
  },

  title: {
    margin: "0 0 8px 0",
    fontSize: "20px",
    fontWeight: 700,
    color: "#111827",
    lineHeight: 1.2,
  },

  text: {
    margin: "0 0 10px 0",
    fontSize: "14px",
    lineHeight: 1.7,
    color: "#4b5563",
  },

  subText: {
    margin: 0,
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#6b7280",
  },

  link: {
    color: "#111827",
    fontWeight: 600,
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "18px",
    flexWrap: "wrap",
  },

  primaryBtn: {
    appearance: "none",
    border: "none",
    background: "#111827",
    color: "#ffffff",
    padding: "12px 18px",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 8px 20px rgba(17,24,39,0.18)",
  },

  secondaryBtn: {
    appearance: "none",
    border: "1px solid rgba(17,24,39,0.12)",
    background: "#f9fafb",
    color: "#111827",
    padding: "12px 18px",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};